<template>
  <div class="topnav" id="topnav">
    <div class="d-flex" style="gap: 25px;">
      <div class="topicon" id="btn_home" @click="handleBackToIndex" v-if="showIndexBtn">
        <img src="@/assets/images/icon_home.png" alt="" class="icon-img" />
        <img src="@/assets/images/button_cover.png" alt="" class="cover-img">
      </div>
      <div class="topicon" id="btn_data" v-if="showDataBtn" @click="handleOpenDataPage">
        <img src="@/assets/images/icon_data.png" alt="" class="icon-img" />
        <img src="@/assets/images/button_cover.png" alt="" class="cover-img">
      </div>
    </div>
    <div class="topicon_Map" id="btn_map" v-if="showMapBtn" @click="handleBackToMap">
      <img
        :src="currentLanguage === 'en' ? require('@/assets/images/icon_map_en.png') : currentLanguage === 'bn' ? require('@/assets/images/icon_map_bn.png') : require('@/assets/images/icon_map.png')"
        alt="" class="icon-img" />
      <img src="@/assets/images/button-cover02.png" alt="" class="cover-img">
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopNavigation',
  props: {
    showIndexBtn: {
      type: Boolean,
      default: false
    },
    showMapBtn: {
      type: Boolean,
      default: false
    },
    showDataBtn: {
      type: Boolean,
      default: false
    },
    currentLanguage: {
      type: String,
      default: 'zh'
    }
  },
  emits: ['back-to-index', 'reload-iframe', 'open-data-page'],
  methods: {
    handleBackToIndex() {
      this.$emit('back-to-index')
    },
    handleBackToMap() {
      this.$emit('back-to-map')
    },
    handleOpenDataPage() {
      this.$emit('open-data-page')
    }
  }
}
</script>

<style scoped>
.topnav {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1000;
  padding: 20px;
  gap: 25px;
  top: 0px;
  width: 100%;
  box-sizing: border-box;
  pointer-events: none;
}

.topicon,
.topicon_Map {
  pointer-events: auto;
}

.topicon {
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.9);
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: rgba(153, 153, 153, 0.7);
}

.topicon_Map {
  height: 50px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.topicon_Map .icon-img {
  height: 100%;
}

.topicon .icon-img {
  width: 60%;
}

.topicon .cover-img {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 0;
  left: 0;
}

.topicon_Map .cover-img {
  position: absolute;
  width: 120%;
  height: 100%;
  top: 0;
  left: -10%;
}

/* Tablet 響應式設計 (768px - 1024px) */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .topnav {
    padding: 30px;
    gap: 35px;
  }

  .topicon {
    width: 80px;
    height: 80px;
    border: 2px solid rgba(255, 255, 255, 0.9);
  }

  .topicon_Map {
    height: 80px;
    border: 2px solid rgba(255, 255, 255, 0.9);
  }

  .topicon .icon-img {
    width: 60%;
  }

  .topicon .cover-img {
    width: 80px;
    height: 80px;
  }
}

/* Large Tablet 響應式設計 (1025px - 1366px) */
@media screen and (min-width: 1025px) and (max-width: 1366px) {
  .topnav {
    padding: 40px;
    gap: 45px;
  }

  .topicon {
    width: 90px;
    height: 90px;
    border: 2px solid rgba(255, 255, 255, 0.9);
  }
   .topicon_Map {
    height: 90px;
    border: 2px solid rgba(255, 255, 255, 0.9);
  }
  .topicon .icon-img {
    width: 60%;
  }

  .topicon .cover-img {
    width: 90px;
    height: 90px;
  }
}

/* Landscape Tablet 響應式設計 */
@media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .topnav {
    padding: 25px;
    gap: 30px;
  }

  .topicon {
    width: 70px;
    height: 70px;
  }
   .topicon_Map {
    height: 70px;
    border: 2px solid rgba(255, 255, 255, 0.9);
  }
  .topicon .cover-img {
    width: 70px;
    height: 70px;
  }
}
</style>